import * as s from "react";
import { shouldThrowError as n } from "./contact-channels116.js";
var i = (r, e) => {
  (r.suspense || r.throwOnError || r.experimental_prefetchInRender) && (e.isReset() || (r.retryOnMount = !1));
}, E = (r) => {
  s.useEffect(() => {
    r.clearReset();
  }, [r]);
}, R = ({
  result: r,
  errorResetBoundary: e,
  throwOnError: t,
  query: a,
  suspense: o
}) => r.isError && !e.isReset() && !r.isFetching && a && (o && r.data === void 0 || n(t, [r.error, a]));
export {
  i as ensurePreventErrorBoundaryRetry,
  R as getHasError,
  E as useClearResetErrorBoundary
};
//# sourceMappingURL=contact-channels173.js.map
